// ./components/Sidebar.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from "react";
import { Home, Globe, Settings, LogOut, CreditCard, FileText, HelpCircle } from 'lucide-react';
import './Sidebar.css';

function Sidebar({ user, onLogout }) {
  const location = useLocation();
  const { t } = useTranslation();

  const navItems = user.role === 'admin'
    ? [
      { to: '/dashboard', label: t('nav.home'), icon: Home }
    ]
    : [
      { to: '/dashboard', label: t('nav.home'), icon: Home },
      { to: '/domains', label: t('nav.domains'), icon: Globe },
      { to: '/billing', label: t('nav.billing') || 'Fatura Bilgilerim', icon: FileText },
      { to: '/payments', label: t('nav.myPayments') || 'Ödemelerim', icon: CreditCard },
      { to: '/how-it-works', label: t('nav.howItWorks') || 'Nasıl Çalışır', icon: HelpCircle },
      { to: '/settings', label: t('nav.settings'), icon: Settings }
    ];

  const [isClosed, setIsClosed] = useState(true);

  useEffect(() => {
    if (!isClosed) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    // component unmount olursa temizle
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isClosed]);

  return (
    <aside className={`sidebar ${isClosed ? "close" : ""}`}>
      <div className="sidebar-header">
        <div className="logo-section" style={{userSelect:'none'}}>
          <div className="logo-icon">
            <img src="/images/ruxLogo-32.png" alt="RUX Engine" className="logo-image" />
          </div>
          <span className="logo-text">RuX Engine</span>
        </div>
        <div className="hamburger" id="hamburger" onClick={() => setIsClosed(!isClosed)}>
          <div className="hamburger-line"></div>
          <div className="hamburger-line"></div>
          <div className="hamburger-line"></div>
        </div>
      </div>

      <nav className="sidebar-nav">
        {navItems.map((item) => {
          const isActive = location.pathname === item.to;
          const IconComponent = item.icon;
          return (
            <Link key={item.to} to={item.to} className={isActive ? 'active' : ''}>
              <IconComponent 
                size={20} 
                strokeWidth={1.5}
                color={isActive ? "#4f46e5" : "#6b7280"} 
              />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer">
        <div className="user-info">
          <div className="avatar">
            {user.fullName?.charAt(0).toUpperCase() || user.email.charAt(0).toUpperCase()}
          </div>
          <div>
            <p className="user-name">{user.fullName || user.email}</p>
            <p className="user-email">{user.email}</p>
          </div>
        </div>
        <button className="logout-button" onClick={onLogout}>
          <LogOut size={16} strokeWidth={1.5} color="#ef4444" />
          <span>{t('auth.logout')}</span>
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
